export function getBorder(noBorder: boolean, isActive: boolean) {
  if (isActive) {
    return '1px solid #52509A';
  }
  if (noBorder) {
    return '1px solid transparent';
  }
  return '1px solid #A8A7CC';
}
